import { Stack, Typography } from '@mui/material'
import { Trans } from 'react-i18next'
import { Box } from '@mui/system'

type ScheduleDialogDescriptionBlockProps = {
  title: string
  description: string
}

const ScheduleDialogDescriptionBlock = ({ title, description }: ScheduleDialogDescriptionBlockProps) => {
  return (
    <Stack>
      <Typography component={'h4'} variant="h5" color="text.highEmphasis" lineHeight={1}>
        {title}
      </Typography>
      <Typography mt={'2px'} flexWrap="wrap" color="text.base">
        <Trans i18nKey={description} components={{ bold: <Box component="span" fontWeight="bold" /> }} />
      </Typography>
    </Stack>
  )
}

export default ScheduleDialogDescriptionBlock